import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/tooltip/withTooltip.sss';

// Usage: <WithTooltip direction="bottom" align="end" tooltip="Tooltip text">text to show tooltip on</HelpTooltip>
// - direction (default right): top | bottom | left | right = position of the tooltip relative to the help icon
// - align (default center): start | center | end = position of the tooltip arrow along the side it sits on
// - tipAlign (default center): start | center | end = position of the tip along the edge of the tooltip box (useful when that element is much wider than the tooltip)

// WARNING: currently broken (misaligned) on Chrome if the page is scrolled
//   waiting on fix at https://issues.chromium.org/issues/419711773

export default class WithTooltip extends Component {
	constructor(props) {
		super(props);
		this.onShowInteraction = this.onShowInteraction.bind(this);
		this.onHideInteraction = this.onHideInteraction.bind(this);
	}

	componentDidMount() {
		if (this.props.always) this.showTooltip();
	}
	componentDidUpdate(prevProps) {
		if (!!this.props.always !== !!prevProps.always) {
			this[this.props.always ? 'showTooltip' : 'hideTooltip']();
		}
	}

	showTooltip() {
		this.base.querySelector('[popover]').showPopover({ source: this.base });
	}
	hideTooltip() {
		this.base.querySelector('[popover]').hidePopover();
	}

	onShowInteraction() {
		if (!this.props.always) this.showTooltip();
	}
	onHideInteraction() {
		if (!this.props.always) this.hideTooltip();
	}

	render(props) {
		const align = props.align || 'center';
		const tipAlign = props.tipAlign || 'center';
		const direction = props.direction || 'right';
		return (
			<div
				class={joinClasses(
					props.class,
					s.wrapper,
					props.dark && s.dark,
					s[`direction-${direction}`],
					s[`align-${align}`],
					s[`tip-align-${tipAlign}`],
				)}
				style={props.style}
				onMouseEnter={this.onShowInteraction}
				onMouseLeave={this.onHideInteraction}
				tabIndex={props.interactive ? null : 0}
				onFocusCapture={this.onShowInteraction}
				onBlurCapture={this.onHideInteraction}
			>
				{props.children}
				<div class={s.tooltip} popover={props.always ? 'manual' : 'hint'}>
					<div class={s.tooltipContent}>
						{props.tooltip}
					</div>
				</div>
			</div>
		);
	}
}